<template>
  <v-card id="Agenda" class="mb-2">
    <v-card-title>
      <div class="d-flex align-center">
        <v-btn elevation="1" class="mr-3" fab small @click="TOGGLE_CLOSED_BLOCK('agenda')" color="white">
          <v-icon>
            mdi-dots-vertical
          </v-icon>
        </v-btn>
        <h2>События</h2>
      </div>

      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        @input="apiSearch"
        append-icon="mdi-magnify"
        label="Поиск по событиям"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      v-if="isShow"
      item-key="uuid"
      :item-class="rowClass"
      :headers="headers"
      :items="items"
      :search="search"
      :loading="loading"
      @click:row="onRowClick"
    >
      <template v-slot:top>
        <v-container fluid>
          <v-row no-gutters justify="space-between">
            <v-col cols="12" sm="3" class="mr-3">
              <date-range-picker v-model="filters.date" @input="load" />
            </v-col>

            <v-col cols="12" sm="3">
              <v-select
                dense
                hide-details
                class="ma-0 pa-0"
                label="Типы событий"
                :items="eventTypes"
                v-model="filters.type"
                @change="load"
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import throttle from "lodash/throttle";
import DateRangePicker from "@/components/forms/DateRangePicker";
import dayjs from "dayjs";
import { uniqueId } from "lodash/util";
import AddDocument from "@/modules/documents/add-document/AddDocument.vue";
import { CustomerService } from "@/services/api/customer.service";
import { mapMutations, mapState } from "vuex";
// new Date().toISOString().substr(0, 10)

export default {
  name: "Agenda",

  components: { DateRangePicker },

  data: () => ({
    loading: true,
    search: "",
    filters: {
      type: "",
      date: [
        dayjs()
          .startOf("month")
          .format("YYYY-MM-DD"),
        dayjs()
          .startOf("month")
          .add(1, "month")
          .format("YYYY-MM-DD"),
      ],
    },
    headers: [
      {
        text: "Событие",
        align: "start",
        sortable: true,
        value: "title",
      },
      {
        text: "Дата",
        align: "end",
        sortable: true,
        value: "date",
      },
      {
        text: "Время",
        align: "end",
        sortable: false,
        value: "time",
      },
    ],
    eventTypes: [],
  }),

  computed: {
    ...mapState("ikp", ["closedBlocks"]),
    isShow() {
      return !this.closedBlocks.includes("agenda");
    },
    customerId() {
      return this.$store.state.customer.id;
    },
    doctorId() {
      return this.$store.state.auth.id;
    },
    items() {
      return this.$store.state.ikp.agenda;
    },
  },

  watch: {},

  async mounted() {
    await Promise.all([this.loadCategoryTypes(), this.load()]);
  },

  methods: {
    ...mapMutations("ikp", ["TOGGLE_CLOSED_BLOCK"]),

    rowClass(row) {
      return row.doc_id ? "cursor-pointer has-doc" : "";
    },
    async onRowClick(row) {
      if (row.doc_id) {
        try {
          const r = await CustomerService.getDocument(this.customerId, row.doc_id);

          const isUpdated = await this.$dialog.showAndWait(AddDocument, {
            customerForm: r,
            readonly: true,
            width: 600,
            doctorId: this.doctorId,
            persistent: true,
          });
        } catch (e) {
          if (e?.response.status === 404) {
            this.$dialog.notify.error(`Документ №${row.doc_id} не найден`);
          } else {
            this.$dialog.notify.error("Не удалось загрузить документ");
          }
        }
      }
    },
    async load() {
      this.loading = true;

      await this.$store.dispatch("ikp/loadAgendaEvents", {
        search: this.search,
        category: this.filters.type,
        start: this.filters.date[0],
        end: this.filters.date[1] || "",
      });

      this.loading = false;
    },

    apiSearch: throttle(async function apiSearchHandler() {
      await this.load();
    }, 1000),

    async loadCategoryTypes() {
      try {
        const response = await this.$http.get(`v1/events/types`);
        this.eventTypes = [{ text: "Все", value: "" }, ...response.data.data.map(item => ({ text: item.name, value: item.id }))];
      } catch (e) {
        // TODO: Обработать ошибку
        console.error(e);
      }
    },
  },
};
</script>

<style>
.cursor-pointer {
  cursor: pointer;
}
.has-doc td:first-child:before {
  content: "\F09EE";
  margin-right: 4px;
  display: inline-block;
  font: normal normal normal 1.5rem/1 "Material Design Icons";
  font-size: inherit;
  text-rendering: auto;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
